
























import Vue from 'vue'
import { Component, Prop} from 'vue-property-decorator'
import { notificationState } from '../../stores/notification'
import Notification from '../atoms_molecules/Notification.vue'
import { chunk } from 'lodash'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'

@Component({
  components: {
    Notification
  }
})
export default class HeaderNotification extends Vue {
  @Prop({ default: '' }) colorNotiIcon: string
  ROUTER_NAME = ROUTER_NAME
  mobile = checkMobile()
  get notifications() {
    return notificationState.notifications
  }

  get unread() {
    return notificationState.unread
  }

  get topNotifications() {
    const examNotiChunk = chunk(this.notifications, 5)
    return examNotiChunk[0] ? examNotiChunk[0] : []
  }

  tab(page) {
    this.$router.push({
      name: page
    })
  }

  onShowNotification() {
    notificationState.getNotification({ checkNotification: true })
  }
}
